export default () => ({
  titlePanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
});



// WEBPACK FOOTER //
// ./src/components/Panels/SpreadPanel.styles.js